// eslint-disable-next-line @typescript-eslint/no-require-imports
const countryData = require('country-telephone-data');

export const countries = countryData.allCountries
  .map((c: { name: string; iso2: string; dialCode: string }) => ({
    name: c.name,
    shortCode: c.iso2,
    code: `+${c.dialCode}`,
    flag: c.iso2
      .toUpperCase()
      .replace(/./g, char => String.fromCodePoint(127397 + char.charCodeAt(0))),
  }))
  .sort((a, b) => a.name.localeCompare(b.name));
